import { NgModule } from '@angular/core';
import { Route, RouterModule } from '@angular/router';

import { PathwayContentInsightsComponent } from '@app/insights/pathway-content-insights/pathway-content-insights.component';
import { PathwayInsightsComponent } from '@app/insights/pathway-insights/pathway-insights.component';
import { PathwayTrackingLinksComponent } from '@app/insights/pathway-tracking-links/pathway-tracking-links.component';

import { PathwayPageGuard } from './guards/pathway-page.guard';

import { PathwayDownloadableReportsComponent } from '../components/pathway/pathway-downloadable-reports/pathway-downloadable-reports.component';
import { PathwayFollowersComponent } from '../components/pathway-followers/pathway-followers.component';

import { PathwayViewComponent } from '../components/pathway';
import { PathwayPageComponent } from '../components/page/pathway-page/pathway-page.component';

let routes: Route[];
routes = [
  {
    path: ':obfuscatedId',
    component: PathwayPageComponent,
    data: { i18nTitle: 'Pathways_Pathway' },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'pathway',
      },
      {
        path: 'pathway',
        component: PathwayViewComponent,
        canActivate: [PathwayPageGuard],
      },
      {
        path: 'enrollees',
        component: PathwayFollowersComponent,
        canActivate: [PathwayPageGuard],
        data: { i18nTitle: 'Pathways_Followers' },
      },
      {
        path: 'insights',
        component: PathwayInsightsComponent,
        canActivate: [PathwayPageGuard],
        data: { i18nTitle: 'Pathways_Insights' },
      },
    ],
  },
  // those routes behave as sibling pages to the root, not real children despite the path
  {
    path: ':obfuscatedId/insights/links',
    component: PathwayTrackingLinksComponent,
    canActivate: [PathwayPageGuard],
    data: { i18nTitle: 'PathwayEnrollmentSource_TrackableLinks' },
  },
  {
    path: ':obfuscatedId/insights/content',
    component: PathwayContentInsightsComponent,
    canActivate: [PathwayPageGuard],
    data: { i18nTitle: 'Core_Content' },
  },
  {
    path: ':obfuscatedId/insights/reporting',
    component: PathwayDownloadableReportsComponent,
    canActivate: [PathwayPageGuard],
    data: { i18nTitle: 'Pathways_Followers' },
  },
  {
    // This will catch old child routes to "/paths"
    path: '**',
    redirectTo: 'error-module/404',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [PathwayPageGuard],
})
export class PathwayRoutingModule {}
